"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodashEs = require("lodash-es");
var _util = require("@/utils/util");
var _store = require("@/api/store");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var basicForm = {
  categoryIds: [],
  executeHour: undefined,
  executeMinute: undefined,
  scheduleValue: 1,
  increaseValue: undefined,
  maxValue: undefined,
  minValue: undefined,
  remark: '',
  name: ''
};
var _default2 = exports.default = {
  name: 'Editor',
  props: {
    tree: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;
    var validateIncreaseValue = function validateIncreaseValue(rule, value, callback) {
      if (_this.increaseType === 0 && (value === undefined || value === null || value === '')) {
        return callback(new Error('请输入固定增长值'));
      }
      callback();
    };

    // const increaseValueRequired = () => {
    //   return this.increaseType === 0
    // };

    var validateMinValue = function validateMinValue(rule, value, callback) {
      if (_this.increaseType === 1 && (value === undefined || value === null || value === '')) {
        return callback(new Error('请输入随机最小值'));
      }
      callback();
    };
    var validateMaxValue = function validateMaxValue(rule, value, callback) {
      if (_this.increaseType === 1 && (value === undefined || value === null || value === '')) {
        return callback(new Error('请输入随机最大值'));
      }
      callback();
    };

    // const rangeValueRequired = () => {
    //   return this.increaseType === 1
    // };

    return {
      dialogVisible: false,
      formData: {},
      increaseType: 0,
      increaseTypeOptions: [{
        label: '固定',
        value: 0
      }, {
        label: '随机区间',
        value: 1
      }],
      nodeMap: new Map(),
      formRules: {
        name: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }],
        scheduleValue: [{
          required: true,
          message: '请输入执行间隔',
          trigger: 'blur'
        }],
        increaseValue: [{
          validator: validateIncreaseValue,
          trigger: 'blur'
        }],
        minValue: [{
          validator: validateMinValue,
          trigger: 'blur'
        }],
        maxValue: [{
          validator: validateMaxValue,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    editorType: function editorType() {
      return this.formData.id ? '编辑' : '新增';
    },
    increaseValueRequired: function increaseValueRequired() {
      return this.increaseType === 0;
    },
    rangeValueRequired: function rangeValueRequired() {
      return this.increaseType === 1;
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this2 = this;
      if (!val) {
        // 弹窗关闭时，彻底清除表单所有红字校验
        this.$nextTick(function () {
          _this2.$refs.editorFormRef.clearValidate();
        });
      }
    }
  },
  methods: {
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.formData = (0, _lodashEs.cloneDeep)(basicForm);
              this.buildMap(this.tree);
              if (data && data.id) {
                console.log('来着干吗', data);
                (0, _util.assignSameProps)(data, this.formData);
                this.formData.id = data.id;
                this.increaseType = !!data.increaseValue ? 0 : 1;
                this.initChecked(this.formData.categoryIds);
              }
              this.dialogVisible = true;
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open(_x) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    close: function close() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm: function resetForm() {
      var _this3 = this;
      this.formData = (0, _lodashEs.cloneDeep)(basicForm);
      this.increaseType = 0;
      this.nodeMap = new Map();
      this.$nextTick(function () {
        if (_this3.$refs.editorFormRef) {
          _this3.$refs.editorFormRef.clearValidate();
        }
      });
      this.initChecked([]);
    },
    // 建立映射
    buildMap: function buildMap(list) {
      var _this4 = this;
      var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      list.forEach(function (node) {
        _this4.nodeMap.set(node.id, node);
        if (node.child && node.child.length) {
          _this4.buildMap(node.child);
        }
      });
    },
    // 初始化选中
    initChecked: function initChecked(ids) {
      var _this5 = this;
      this.$nextTick(function () {
        _this5.$refs.treeRef.setCheckedKeys(ids);
      });
    },
    // 输出结果
    getCheckedIds: function getCheckedIds() {
      var _this6 = this;
      var checkedKeys = this.$refs.treeRef.getCheckedKeys();
      var checkedSet = new Set(checkedKeys);
      var result = [];

      /**
       * DFS 压缩
       */
      var _dfs = function dfs(node) {
        // 叶子节点
        if (!node.child || !node.child.length) {
          if (checkedSet.has(node.id)) {
            result.push(node.id);
            return true;
          }
          return false;
        }

        // 递归子节点
        var checkedChildrenCount = 0;
        node.child.forEach(function (child) {
          var checked = _dfs(child);
          if (checked) {
            checkedChildrenCount++;
          }
        });

        // 当前节点是否被选中
        var selfChecked = checkedSet.has(node.id);

        /**
         * 所有子节点都选中
         * 压缩成父节点
         */
        if (selfChecked && checkedChildrenCount === node.child.length) {
          // 删除刚刚加入的子节点
          node.child.forEach(function (child) {
            _this6.removeDescendantResult(child, result);
          });
          result.push(node.id);
          return true;
        }
        return selfChecked || checkedChildrenCount > 0;
      };
      this.tree.forEach(function (root) {
        _dfs(root);
      });
      return result;
    },
    /**
     * 删除后代节点结果
     */
    removeDescendantResult: function removeDescendantResult(node, result) {
      var _this7 = this;
      var index = result.indexOf(node.id);
      if (index > -1) {
        result.splice(index, 1);
      }
      if (node.child && node.child.length) {
        node.child.forEach(function (child) {
          _this7.removeDescendantResult(child, result);
        });
      }
    },
    handleScheduleValueBlur: function handleScheduleValueBlur() {
      // 判断是否为空，若为空则重置为 1
      if (this.formData.scheduleValue === undefined || this.formData.scheduleValue === null) {
        this.formData.scheduleValue = 1;
      }
    },
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var valid, checkedIds, isNew, data, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return this.$refs.editorFormRef.validate();
            case 1:
              valid = _context2.v;
              if (valid) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              checkedIds = this.getCheckedIds();
              if (checkedIds.length) {
                _context2.n = 3;
                break;
              }
              this.$message.error('未选择分类');
              return _context2.a(2);
            case 3:
              isNew = true;
              data = (0, _lodashEs.cloneDeep)(this.formData);
              data.categoryIds = checkedIds;
              if (this.increaseType === 0) {
                data.minValue = null;
                data.maxValue = null;
              } else {
                data.increaseValue = null;
              }
              if (!data.id) {
                _context2.n = 5;
                break;
              }
              _context2.n = 4;
              return (0, _store.updateFictiTask)(data);
            case 4:
              isNew = false;
              _context2.n = 6;
              break;
            case 5:
              _context2.n = 6;
              return (0, _store.createFictiTask)(data);
            case 6:
              this.$message.success("".concat(this.editorType, "\u6210\u529F"));
              this.$emit('success', isNew);
              this.close();
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
              console.error("\u865A\u62DF\u9500\u91CF\u4EFB\u52A1".concat(this.editorType), _t);
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }
};